(function(){
  'use strict';

  function all(selector, root){
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function navHeight(){
    var nav = document.querySelector('[data-ap-uk-loyalty-nav]');
    return nav ? nav.getBoundingClientRect().height : 0;
  }

  function scrollToTarget(target){
    if (!target) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - navHeight() - 18;
    window.scrollTo({top:Math.max(0,top),behavior:reduce ? 'auto' : 'smooth'});
  }

  function bindAnchorLinks(){
    all('[data-ap-uk-loyalty-nav] a[href^="#"], [data-ap-uk-loyalty] a[href^="#loyalty-"]').forEach(function(link){
      if (link.dataset.apLoyaltyAnchorBound === '1') return;
      link.dataset.apLoyaltyAnchorBound = '1';
      link.addEventListener('click',function(event){
        var selector = link.getAttribute('href');
        if (!selector || selector === '#') return;
        var target;
        try { target = document.querySelector(selector); } catch(error) { return; }
        if (!target) return;
        event.preventDefault();
        scrollToTarget(target);
        if (history.replaceState) history.replaceState(null,'',selector);
      });
    });
  }

  function bindActiveNavigation(){
    all('[data-ap-uk-loyalty-nav]').forEach(function(nav){
      if (nav.dataset.apLoyaltySpyBound === '1') return;
      nav.dataset.apLoyaltySpyBound = '1';
      var links = all('a[href^="#"]',nav);
      var items = links.map(function(link){
        var target;
        try { target = document.querySelector(link.getAttribute('href')); } catch(error) { target = null; }
        return {link:link,target:target};
      }).filter(function(item){ return !!item.target; });
      if (!items.length) return;

      var frame = null;
      function update(){
        frame = null;
        var line = nav.getBoundingClientRect().bottom + 38;
        var active = items[0];
        items.forEach(function(item){
          if (item.target.getBoundingClientRect().top <= line) active = item;
        });
        if (window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4) active = items[items.length - 1];
        items.forEach(function(item){
          var isActive = item === active;
          item.link.classList.toggle('is-active',isActive);
          if (isActive) item.link.setAttribute('aria-current','location');
          else item.link.removeAttribute('aria-current');
        });
      }
      function requestUpdate(){
        if (frame) return;
        frame = window.requestAnimationFrame(update);
      }
      window.addEventListener('scroll',requestUpdate,{passive:true});
      window.addEventListener('resize',requestUpdate,{passive:true});
      requestUpdate();
      window.setTimeout(requestUpdate,500);
      window.setTimeout(requestUpdate,1800);
    });
  }

  function cwillTextSettings(){
    var section = document.querySelector('[data-ap-uk-loyalty][data-cwill-redeem-title]');
    if (!section) return null;
    return {
      earnEyebrow: section.getAttribute('data-cwill-earn-eyebrow') || 'EARN AP CREDITS',
      earnTitle: section.getAttribute('data-cwill-earn-title') || 'Ways to earn',
      earnText: section.getAttribute('data-cwill-earn-text') || 'Earn more AP Credits through eligible purchases and activities.',
      eyebrow: section.getAttribute('data-cwill-redeem-eyebrow') || 'REWARDS CENTER',
      title: section.getAttribute('data-cwill-redeem-title') || 'Turn AP Credits into rewards',
      text: section.getAttribute('data-cwill-redeem-text') || 'Choose how you want to use your AP Credits.',
      couponTab: section.getAttribute('data-cwill-coupon-tab') || 'Discount Coupons',
      productTab: section.getAttribute('data-cwill-product-tab') || 'Products',
      ticketLabel: section.getAttribute('data-cwill-ticket-label') || 'ALLPOWERS REWARDS',
      actionLabel: section.getAttribute('data-cwill-action-label') || 'Redeem in CWILL'
    };
  }

  function enhanceCwillEarn(){
    var settings = cwillTextSettings();
    var root = document.querySelector('#loloyal-ways-to-earn');
    if (!settings || !root) return false;
    document.documentElement.classList.add('ap-uk-loyalty-page');
    document.body.classList.add('ap-uk-loyalty-page');

    var header = root.querySelector('.ll-page-header');
    var heading = root.querySelector('.ll-page-title');
    var subtitle = root.querySelector('.ll-page-subtitle');
    var cards = root.querySelector('.ll-page-cards');
    if (!header || !heading || !subtitle || !cards) return false;

    if (!header.querySelector('.ap-cwill-eyebrow')) {
      var eyebrow = document.createElement('span');
      eyebrow.className = 'ap-cwill-eyebrow';
      header.insertBefore(eyebrow,heading);
    }
    header.querySelector('.ap-cwill-eyebrow').textContent = settings.earnEyebrow;
    heading.textContent = settings.earnTitle;
    subtitle.textContent = settings.earnText;
    root.classList.add('ap-cwill-earn--enhanced');
    return true;
  }

  function rewardType(card){
    var icon = card.querySelector('hashcoop-icon');
    var iconName = icon ? (icon.getAttribute('name') || '') : '';
    var title = card.querySelector('.ll-cards-title');
    var titleText = title ? title.textContent : '';
    return iconName === 'percentage-off' || /%\s*off/i.test(titleText) ? 'coupon' : 'product';
  }

  function ticketValue(card, type){
    var title = card.querySelector('.ll-cards-title');
    var text = title ? title.textContent.replace(/\s+/g,' ').trim() : '';
    if (type === 'coupon') return text.replace(/\s*coupons?\s*$/i,'').toUpperCase();
    return text.replace(/^free\s+/i,'').replace(/\s*coupons?\s*$/i,'').toUpperCase();
  }

  function decorateRewardCard(card, settings){
    if (card.dataset.apCwillDecorated === '1') return;
    card.dataset.apCwillDecorated = '1';
    var type = rewardType(card);
    card.dataset.apRewardType = type;

    var ticket = document.createElement('div');
    ticket.className = 'ap-cwill-ticket ap-cwill-ticket--' + type;
    var frame = document.createElement('div');
    frame.className = 'ap-cwill-ticket__frame';
    var label = document.createElement('span');
    label.className = 'ap-cwill-ticket__label';
    label.textContent = settings.ticketLabel;
    var value = document.createElement('strong');
    value.className = 'ap-cwill-ticket__value';
    value.textContent = ticketValue(card,type);
    frame.appendChild(label);
    frame.appendChild(value);
    ticket.appendChild(frame);
    card.insertBefore(ticket,card.firstChild);

    var action = card.querySelector('.ll-action-content');
    if (action && !action.querySelector('.ap-cwill-action-label')) {
      var actionLabel = document.createElement('span');
      actionLabel.className = 'ap-cwill-action-label';
      actionLabel.textContent = settings.actionLabel;
      action.appendChild(actionLabel);
    }
  }

  function setRewardTab(root, name){
    all('.ap-cwill-tab',root).forEach(function(button){
      var active = button.dataset.rewardTab === name;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-selected',active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
    });
    all('.ll-page-cards-item',root).forEach(function(card){
      card.hidden = card.dataset.apRewardType !== name;
    });
  }

  function enhanceCwillRedeem(){
    var settings = cwillTextSettings();
    var root = document.querySelector('#loloyal-ways-to-redeem');
    if (!settings || !root) return false;
    document.documentElement.classList.add('ap-uk-loyalty-page');
    document.body.classList.add('ap-uk-loyalty-page');

    var header = root.querySelector('.ll-page-header');
    var heading = root.querySelector('.ll-page-title');
    var subtitle = root.querySelector('.ll-page-subtitle');
    var cardsWrap = root.querySelector('.ll-page-cards');
    if (!header || !heading || !subtitle || !cardsWrap) return false;

    if (!header.querySelector('.ap-cwill-eyebrow')) {
      var eyebrow = document.createElement('span');
      eyebrow.className = 'ap-cwill-eyebrow';
      header.insertBefore(eyebrow,heading);
    }
    header.querySelector('.ap-cwill-eyebrow').textContent = settings.eyebrow;
    heading.textContent = settings.title;
    subtitle.textContent = settings.text;

    var cards = all('.ll-page-cards-item',cardsWrap);
    if (!cards.length) return false;
    cards.forEach(function(card){ decorateRewardCard(card,settings); });
    cards.sort(function(a,b){
      return a.dataset.apRewardType === b.dataset.apRewardType ? 0 : (a.dataset.apRewardType === 'coupon' ? -1 : 1);
    }).forEach(function(card){ cardsWrap.appendChild(card); });

    var tabs = root.querySelector('.ap-cwill-tabs');
    if (!tabs) {
      tabs = document.createElement('div');
      tabs.className = 'ap-cwill-tabs';
      tabs.setAttribute('role','tablist');
      tabs.setAttribute('aria-label','Choose a reward type');
      ['coupon','product'].forEach(function(name){
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ap-cwill-tab';
        button.dataset.rewardTab = name;
        button.setAttribute('role','tab');
        button.addEventListener('click',function(){ setRewardTab(root,name); });
        tabs.appendChild(button);
      });
      cardsWrap.parentNode.insertBefore(tabs,cardsWrap);
    }
    var couponButton = tabs.querySelector('[data-reward-tab="coupon"]');
    var productButton = tabs.querySelector('[data-reward-tab="product"]');
    if (couponButton) couponButton.textContent = settings.couponTab;
    if (productButton) productButton.textContent = settings.productTab;
    if (!root.dataset.apCwillInitialTab) {
      root.dataset.apCwillInitialTab = 'coupon';
      setRewardTab(root,'coupon');
    } else {
      var selected = tabs.querySelector('[aria-selected="true"]');
      setRewardTab(root,selected ? selected.dataset.rewardTab : 'coupon');
    }
    root.classList.add('ap-cwill-redeem--enhanced');
    return true;
  }

  function observeCwillRedeem(){
    var frame = null;
    var observer = new MutationObserver(function(){
      if (frame) return;
      frame = window.requestAnimationFrame(function(){
        frame = null;
        if (enhanceCwillRedeem()) observer.disconnect();
      });
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
    if (enhanceCwillRedeem()) observer.disconnect();
    window.setTimeout(enhanceCwillRedeem,500);
    window.setTimeout(enhanceCwillRedeem,1800);
  }

  function observeCwillEarn(){
    var frame = null;
    var observer = new MutationObserver(function(){
      if (frame) return;
      frame = window.requestAnimationFrame(function(){
        frame = null;
        if (enhanceCwillEarn()) observer.disconnect();
      });
    });
    observer.observe(document.documentElement,{childList:true,subtree:true});
    if (enhanceCwillEarn()) observer.disconnect();
    window.setTimeout(enhanceCwillEarn,500);
    window.setTimeout(enhanceCwillEarn,1800);
  }

  function init(){
    bindAnchorLinks();
    bindActiveNavigation();
    enhanceCwillEarn();
    enhanceCwillRedeem();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
  observeCwillEarn();
  observeCwillRedeem();
})();
